module.exports = __webpack_public_path__ + "static/media/stock-insufficient.be0d5eb7.svg";